import api from "./axios";

class ServiceTalhao {
  async save(talhao) {
    const { data } = await api.post("/talhoes", talhao);
    return data.id;
  }

  async update(talhao) {
    await api.put(`/talhoes/${talhao.id}`, talhao);
  }

  async delete(id) {
    await api.delete(`/talhoes/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/talhoes/${id}`);
    return data;
  }

  async findByPropertyId(idPropriedade) {
    const { data } = await api.get(`/talhoes/propriedade/${idPropriedade}`);
    return data;
  }
}

export default new ServiceTalhao();
